import { Form } from 'antd';
import { FormItemLayout } from 'antd/es/form/Form';
import { Validations } from 'interfaces';
import useFormValidation from 'utils/useFormValidation';
import { StyledAutoComplete } from './style';
import { Rule } from 'rc-field-form/lib/interface';
import { BaseOptionType, DefaultOptionType } from 'antd/es/select';

export interface AutoCompleteProps extends Validations {
  label?: string;
  name?: (string | number)[] | string | number;
  layout?: FormItemLayout;
  initialValue?: string | string[] | number | number[];
  rules?: Rule[];
  onSearch?: ((value: string) => void) | undefined;
  placeholder?: React.ReactNode;
  options?: (DefaultOptionType | BaseOptionType)[] | undefined;
  size?: 'large' | 'middle' | 'small';
}

export const AutoComplete = ({
  label,
  name,
  layout,
  initialValue,
  validations,
  rules,
  onSearch,
  placeholder,
  options,
  size = 'large',
}: AutoCompleteProps) => {
  const { formValidations } = useFormValidation();
  const combinedRules = validations ? formValidations(validations) : rules;
  return (
    <Form.Item
      label={label}
      name={name}
      initialValue={initialValue}
      rules={combinedRules}
      layout={layout}
    >
      <StyledAutoComplete
        size={size}
        onSearch={onSearch}
        placeholder={placeholder}
        options={options}
      />
    </Form.Item>
  );
};
